import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface InfoBannerProps {
  tone?: "info" | "warning" | "success";
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

const toneClasses: Record<NonNullable<InfoBannerProps["tone"]>, string> = {
  info: "bg-accent-soft text-fg",
  warning: "bg-warning-soft text-fg",
  success: "bg-success-soft text-fg",
};

const iconToneClasses: Record<NonNullable<InfoBannerProps["tone"]>, string> = {
  info: "text-accent",
  warning: "text-warning",
  success: "text-success",
};

/**
 * Bilgi şeridi — mockup "Yeni sözleşme, mevcut çalışma alanınız olan **X** içinde
 * oluşturulacaktır." ve benzeri statik uyarı/bilgi kutuları. Kenarlık YOK — spec §5.
 */
export function InfoBanner({ tone = "info", icon, children, className }: InfoBannerProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-2.5 rounded-md px-4 py-3.5",
        toneClasses[tone],
        className,
      )}
    >
      {icon ? (
        <span
          aria-hidden="true"
          className={cn("mt-0.5 flex shrink-0 [&_svg]:size-[18px]", iconToneClasses[tone])}
        >
          {icon}
        </span>
      ) : null}
      <div className="text-[13px] leading-5">{children}</div>
    </div>
  );
}
